"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _CwPodLayout = _interopRequireDefault(require("./CwPodLayout.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var CwPodLayout = function CwPodLayout(props) {
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_CwPodLayout.default.wrap, props.className)
  }, _react.default.createElement("div", {
    className: (0, _classnames.default)(_CwPodLayout.default.podLayoutGrid, (0, _defineProperty2.default)({}, _CwPodLayout.default.defaultDynLayout, !props.customLayout))
  }, props.children));
};

var _default = CwPodLayout;
exports.default = _default;